import { NonOptional, OmitStrict } from '@tanium/coreui-utils';
import { SELECTION_MODE_INCLUDE } from '@tanium/react-use-selection';
import { Id } from '../../types/Id';
import { FullHeightStackedRibbonListProps } from '../../types/StackedRibbonListComponentTypes';
import { HeaderWrapperProps } from './ResultsHeaderWrapper';

type UseHeaderWrapperReturnType<TId extends Id, TItem> = NonOptional<
  OmitStrict<HeaderWrapperProps<TId, TItem>, 'children'>
>;

export const useResultsHeaderWrapper = <TId extends Id, TItem>(
  props: FullHeightStackedRibbonListProps<TId, TItem>,
): UseHeaderWrapperReturnType<TId, TItem> => {
  const {
    advancedFilters,
    defaultFilterText,
    filterPlaceholder,
    filterText,
    itemCount,
    itemsLabel,
    listActions,
    onFilterTextChange,
    quickFilters,
    rowActions,
    selectedWellBg,
    selection = new Set([]),
    selectionMode = SELECTION_MODE_INCLUDE,
    totalItemCount,
    width = '100%',
    listActionsPlacement,
  } = props;

  return {
    listActionsPlacement,
    advancedFilters,
    defaultFilterText,
    filterPlaceholder,
    filterText,
    itemCount,
    itemsLabel,
    listActions,
    onFilterTextChange,
    quickFilters,
    rowActions,
    selectedWellBg,
    selection,
    selectionMode,
    totalItemCount,
    width,
  };
};
